import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';

import More from './more';
import { QuickBetsContent } from './quickBetsContent';

export const MoreContentWrapper = observer(
  ({
    activeFreeBet,
    selectedMarket,
    redBetTypeData,
    activeTabIndex,
    moreBetTypeData,
    blackBetTypeData,
    setSelectedMarket,
  }) => {
    return isMobile() ? (
      <QuickBetsContent
        activeFreeBet={activeFreeBet}
        activeTabIndex={activeTabIndex}
        selectedMarket={selectedMarket}
        setSelectedMarket={setSelectedMarket}
        marketData={activeTabIndex === 3 ? blackBetTypeData : redBetTypeData}
      />
    ) : (
      <More
        activeFreeBet={activeFreeBet}
        selectedMarket={selectedMarket}
        moreBetTypeData={moreBetTypeData}
        setSelectedMarket={setSelectedMarket}
      />
    );
  }
);
